import { getTitle } from '@src/state/site/selectors'
import { RootState } from '@src/state/types'
import * as React from 'react'
import { Helmet as HelmetBase } from 'react-helmet'
import { connect } from 'react-redux'

interface HelmetStateMappedToProps {
  titleText: string
}

const Helmet: React.FunctionComponent<HelmetStateMappedToProps> = ({ titleText }) => (
  <HelmetBase>
    <title>{titleText}</title>
  </HelmetBase>
)

const mapStateToProps = (state: RootState): HelmetStateMappedToProps => ({
  titleText: getTitle(state),
})

export default connect(mapStateToProps)(Helmet)



// WEBPACK FOOTER //
// ./src/components/Helmet/index.tsx